<template>
  <div class="page-wrapper" style="padding-top: 0">
    <div>
      <Button type="primary" @click="addTypeItem" v-p="{api:'housetype/edit'}">添加房型信息</Button>
    </div>
    <type-item v-for="(item,index) in dataListCopy"
               :formData="item"
               :index="index"
               @deleteitem="deleteItem"
               :ref="'typeitem'+index"
               :key="'keyA'+index"
               :houseTypeEnum="houseTypeEnum"
    ></type-item>
    <div>
      <save-and-cancel @save="save" @cancel="cancel" v-p="{api:'housetype/edit'}">
      </save-and-cancel>
    </div>
  </div>
</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import TypeItem from '../../components/TypeItem'
  import {housetypeToEdit, housetypeUpdate, housetypeVaild} from "../../../../../api/project";
  import {deepClone} from "../../../../../utils/format";
  import { getSelectHouseTypes } from 'api/project'
  export default {
    name: 'TypeUpdate',
    props: {
      projectFid: {
        type: String,
        default: null
      },
    },
    components: {
      SaveAndCancel,
      TypeItem
    },
    data() {
      return {
        typeList: [1],
        dataList: [],
        dataListCopy: [],
        houseTypeEnum:[],
      }
    },
    watch: {
      dataList(value) {
        this.dataListCopy = deepClone(value)
      },
      projectFid() {
        this.getTypeInfo()
      }
    },
    methods: {
      deleteItem(index) {
        this.$Modal.confirm({
          content: '<p>确认删除本条房型记录？</p>',
          onOk: () => {
            var item = this.dataListCopy[index]
            if (!item.fid) {
              this.dataListCopy.splice(index, 1)
            }
            else {   //存在fid需要校验
              let params = {
                houseTypeFId: item.fid
              }
              housetypeVaild(params).then(res => {
                this.dataListCopy.splice(index, 1)
              }).catch(error=>{})
            }
          }
        })
      },
      validForm() {
        var flag = true
        for (var i  in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].$refs['typeItem'].validate(bool => {
            if (bool == false) {
              flag = false
            }
          })
        }
        return flag
      },
      getTypeInfo() {
        if (!this.projectFid) {
          return
        }
        var params = {
          projectFid: this.projectFid
        }
        housetypeToEdit(params).then(res => {
          this.dataList = res.data
        }).catch(error => {

        })
        getSelectHouseTypes().then( res => {
          this.houseTypeEnum = res.data
        })
      },
      housetypeUpdate() {
        var params = {
          projectFid: this.projectFid,
          houseTypeDtos: this.dataListCopy
        }
        housetypeUpdate(params).then(res => {
          this.$Message.success('房型信息修改成功')
        })
      },

      save() {
        if (!this.validForm()) {
          this.$Message.info('请检查填写内容！')
          return
        }
        this.housetypeUpdate()

      },
      cancel() {
        this.dataListCopy = deepClone(this.dataList)
        for (var i  in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].$refs['typeItem'].resetFields()
        }
      },
      addTypeItem() {
        this.dataListCopy.push(
          {
            "houseTypeArea": '',
            "houseTypeBathroom": '',
            "houseTypeDescription": "",
            "houseTypeHall": "",
            "houseTypeName": "",
            "houseTypeImage": "",
            "houseType":"",
            "houseTypeRooms": "",
            "projectFid": this.projectFid,
            "remark": ""
          }
        )

      }
    },
    created() {
      this.getTypeInfo()
    }
  }
</script>
<style scoped>

</style>
